import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination
} from '@material-ui/core';

import { IsNoU } from 'common/utils';

// >> redux
import {
  setCategoryChecks
} from '../../../../redux/actions/categories';
// <<

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const CategoryTable = (props) => {
  const { 
    className, 
    userRole,
    categories, 
    onSetSelectedCategories,
    onClickOpenRegisterDialog,
    onClickOpenEditDialog,
    onClickOpenDeleteDialog,
    onClickOpenOrderDialog,
    disableEditButton,
    disableDeleteButton, 
    ...rest } = props;

  const classes = useStyles();

  const [selectedCategories, setSelectedCategories] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  

  const handleSelectAll = event => {

    let selectedCategories;

    if (event.target.checked) {
      //selectedCategories = categories.map(category => category.id);
      selectedCategories = categories.filter(category => {
        if (category.have_ads) {
          return false;
        }
        return true;
      });
      selectedCategories = selectedCategories.map(category => category.id);
    } else {
      selectedCategories = [];
    }

    setSelectedCategories(selectedCategories);
    //props.setCategoryChecks(selectedCategories);
    onSetSelectedCategories(selectedCategories);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedCategories.indexOf(id);
    let newSelectedCategories = [];

    if (selectedIndex === -1) {
      newSelectedCategories = newSelectedCategories.concat(selectedCategories, id);
    } else if (selectedIndex === 0) {
      newSelectedCategories = newSelectedCategories.concat(selectedCategories.slice(1));
    } else if (selectedIndex === selectedCategories.length - 1) {
      newSelectedCategories = newSelectedCategories.concat(selectedCategories.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedCategories = newSelectedCategories.concat(
        selectedCategories.slice(0, selectedIndex),
        selectedCategories.slice(selectedIndex + 1)
      );
    }

    setSelectedCategories(newSelectedCategories);
    //console.log(newSelectedCategories);
    //props.setCategoryChecks(newSelectedCategories);
    onSetSelectedCategories(newSelectedCategories);
  };

  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(event.target.value);
  };

  useEffect(() => {
    //console.log('componentDidUpdate & templates changed');

    const newSelected = selectedCategories.filter(id => {
      const findObj = categories.find(obj => obj.id == id);
      return findObj !== undefined && findObj !== null;
    });

    setSelectedCategories(newSelected);
    onSetSelectedCategories(newSelected);

  }, [categories]);

  return (
    <div>
      {userRole !== 'user' && (
        <div className={classes.row} spacing={2}>
          
          <Button
            color="primary"
            variant="contained"
            onClick={ onClickOpenRegisterDialog }
            hidden={userRole === 'user'}
          >
            등록
          </Button>

          <Button
            color="primary"
            variant="contained"
            disabled={ disableEditButton }
            onClick={ onClickOpenEditDialog }
          >
            수정
          </Button>

          <Button
            style={{
              //  borderRadius: 35,
                backgroundColor: disableDeleteButton ? "#DCDBDC" : "#E00000",
                color: disableDeleteButton ? "#A6A6A6":"#FFFFFF"
                // padding: "18px 36px",
                // fontSize: "18px"
              }}
            variant="contained"
            disabled={ disableDeleteButton }
            onClick={ onClickOpenDeleteDialog }
          >
            삭제
          </Button>

          <Button
            color="primary"
            variant="contained"
            disabled={ (IsNoU(categories) || categories.length <= 1) }
            onClick={ onClickOpenOrderDialog }
          >
            순서
          </Button>

        </div>
      )}

      <Card
        {...rest}
        className={clsx(classes.root, className)}
      >
        <CardContent className={classes.content}>
          <PerfectScrollbar>
            <div className={classes.inner}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={categories.length > 0 && selectedCategories.length === categories.length}
                        color="primary"
                        indeterminate={
                          selectedCategories.length > 0 &&
                          selectedCategories.length < categories.length
                        }
                        onChange={handleSelectAll}
                      />
                    </TableCell>
                    <TableCell>번호</TableCell>
                    <TableCell>카테고리명</TableCell>
                    <TableCell>탬플릿</TableCell>
                    <TableCell>저장경로</TableCell>
                    <TableCell>수정자</TableCell>
                    <TableCell>수정일</TableCell>
                    <TableCell>카테고리 설명</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {categories.slice(page*rowsPerPage, page*rowsPerPage+rowsPerPage).map((category, index) => (
                    <TableRow
                      className={classes.tableRow}
                      hover
                      key={category.id}
                      selected={selectedCategories.indexOf(category.id) !== -1}
                    >
                      <TableCell padding="checkbox">
                      {/* {console.log('category have ads ' + category.have_ads)} */}
                        <Checkbox
                          checked={selectedCategories.indexOf(category.id) !== -1}
                          color="primary"
                          onChange={event => handleSelectOne(event, category.id)}
                          value="true"
                          disabled={category.have_ads}
                        />
                      </TableCell>
                      <TableCell>{index}</TableCell>
                      <TableCell>
                        <div key={category.name+index} className={classes.nameContainer}>
                          {/* <Avatar
                            className={classes.avatar}
                            src={category.avatarUrl}
                          >
                            {getInitials(category.name)}
                          </Avatar> */}
                          <Typography variant="body1">{category.name}</Typography>
                        </div>
                      </TableCell>
                      <TableCell>{category.template}</TableCell>
                      <TableCell>{category.save_path}</TableCell>
                      <TableCell>{category.modified_user}</TableCell>
                      <TableCell>
                        {moment(category.modified_at).format('YYYY-MM-DD')}
                      </TableCell>
                      <TableCell>{category.description}</TableCell>
                      {/* <TableCell>{category.email}</TableCell>
                      <TableCell>
                        {category.address.city}, {category.address.state},{' '}
                        {category.address.country}
                      </TableCell>
                      <TableCell>{category.phone}</TableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </PerfectScrollbar>
        </CardContent>
        <CardActions className={classes.actions}>
          <TablePagination
            component="div"
            labelRowsPerPage=''
            count={categories.length}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleRowsPerPageChange}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </CardActions>
      </Card>

    </div>
  );
};

CategoryTable.propTypes = {
  className: PropTypes.string,
  categories: PropTypes.array.isRequired
};

export default CategoryTable;

// const mapStateToProps = state => ({
//   categories: state.categories.categoriesList
// });

// const mapDispatchToProps = dispatch => ({
//   // getCategories: () => {getCategories(dispatch)},
//   // addCategory: (category) => {addCategory(category, dispatch)},
//   //setCategoryChecks: (checks) => {setCategoryChecks(checks, dispatch)},
// })

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps,
// )(CategoryTable);